import { render, staticRenderFns } from "./testimonials.global.vue?vue&type=template&id=b18c7e62&scoped=true&"
import script from "./testimonials.global.vue?vue&type=script&lang=js&"
export * from "./testimonials.global.vue?vue&type=script&lang=js&"
import style0 from "./testimonials.global.vue?vue&type=style&index=0&id=b18c7e62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18c7e62",
  null
  
)

export default component.exports